import { BorderColor } from "@mui/icons-material";
import { createTheme } from "@mui/material";

const useCustomTheme = (darkMode) => {
  let customTheme = createTheme({
    typography: {
      fontFamily: "'Poppins', sans-serif",
      fontWeightRegular: 400,
      fontWeightMedium: 500,
      fontWeightBold: 700,
    },
  });
  customTheme = createTheme(
    customTheme,
    darkMode
      ? {
          palette: {
            mode: "dark",
            primary: customTheme.palette.augmentColor({
              color: {
                main: "#121212",
              },
              name: "primary",
            }),
            secondary: customTheme.palette.augmentColor({
              color: {
                main: "#ffffff",
              },
              name: "secondary",
            }),
            accent: customTheme.palette.augmentColor({
              color: {
                main: "#171C26",
              },
              name: "accent",
            }),
            pink: customTheme.palette.augmentColor({
              color: {
                main: "#E552FF",
              },
              name: "pink",
            }),
            blue: customTheme.palette.augmentColor({
              color: {
                main: "#01D4FA",
              },
              name: "blue",
            }),
            black: customTheme.palette.augmentColor({
              color: {
                main: "#040404",
              },
              name: "black",
            }),
          },
          components: {
            MuiDateCalendar: {
              styleOverrides: {
                root: {
                  color: "#ffffff",
                  backgroundColor: "#171C26",
                  "& .MuiDayCalendar-weekDayLabel": {
                    color: "#ffffff",
                  },
                  "& .MuiSvgIcon-root": {
                    color: "#ffffff",
                  },
                  "& .MuiPickersDay-root": {
                    color: "#ffffff",
                  },
                },
              },
            },
          },
        }
      : {
          palette: {
            mode: "light",
            background: customTheme.palette.augmentColor({
              color: {
                main: "#ffffff",
              },
              name: "background",
            }),
            primary: customTheme.palette.augmentColor({
              color: {
                main: "#ffffff",
              },
              name: "primary",
            }),
            secondary: customTheme.palette.augmentColor({
              color: {
                main: "#121212",
              },
              name: "secondary",
            }),
            accent: customTheme.palette.augmentColor({
              color: {
                main: "#fff2f8",
              },
              name: "accent",
            }),
            pink: customTheme.palette.augmentColor({
              color: {
                main: "#E552FF",
              },
              name: "pink",
            }),
            blue: customTheme.palette.augmentColor({
              color: {
                main: "#01D4FA",
              },
              name: "blue",
            }),
            black: customTheme.palette.augmentColor({
              color: {
                main: "#FFFFFF",
              },
              name: "black",
            }),
            components: {
              MuiDateCalendar: {
                styleOverrides: {
                  root: {
                    color: "#ffffff",
                    borderRadius: "6px",
                    borderWidth: "1px",
                    border: "1px solid #c4c4c4",
                    backgroundColor: "#121212",
                  },
                },
              },
            },
          },
        }
  );

  return { customTheme };
};

export default useCustomTheme;
